import { useCallback } from "react";
import PropTypes from "prop-types";
import { Box, SimpleGrid } from "@chakra-ui/react";
import SnapshotMakerPreview from "./SnapshotMakerPreview";

const SnapshotMakerTemplateList = ({
  selectedId,
  items = [],
  previewData,
  sizeConfig,
  watermark,
  onTemplateChange,
}) => {
  const handleTemplateChange = useCallback((template) => () => {
    onTemplateChange?.(template);
  }, [onTemplateChange]);

  return (
    <SimpleGrid spacing="2" gridTemplateColumns="repeat(auto-fit, minmax(80px, max-content))">
      {items.map((template) => (
        <Box
          key={template.id}
          onClick={handleTemplateChange(template)}
          width="96px"
          maxWidth="100%"
          borderRadius="sm"
          overflow="hidden"
          position="relative"
          outline={selectedId && template.id === selectedId ? "2px solid" : null}
          outlineOffset="1px"
          outlineColor="primary.400"
          cursor="pointer"
        >
          <SnapshotMakerPreview
            data={previewData}
            sizeConfig={sizeConfig}
            backgroundConfig={template.background}
            cardConfig={template.card}
            watermark={watermark}
          />
        </Box>
      ))}
    </SimpleGrid>
  );
};

SnapshotMakerTemplateList.propTypes = {
  selectedId: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      card: PropTypes.shape({}),
      background: PropTypes.shape({}),
    }),
  ),
  previewData: PropTypes.shape({}),
  sizeConfig: PropTypes.shape({}),
  watermark: PropTypes.bool,
  onTemplateChange: PropTypes.func,
};

SnapshotMakerTemplateList.defaultProps = {
  selectedId: undefined,
  items: undefined,
  previewData: undefined,
  sizeConfig: undefined,
  watermark: undefined,
  onTemplateChange: undefined,
};

export default SnapshotMakerTemplateList;
